import React from "react";
import { FilterRenderContextType } from "./types";

export const FilterListRenderContextType = React.createContext<
  FilterRenderContextType | undefined
>(undefined);
